export const YEAR_FORMAT = "yyyy";
export const YYYY_JAPAN = "yyyy年";
export const MONTH_FORMAT = "MM";
export const MM_JAPAN = "MM月";
export const YEAR_MONTH_FORMAT = "yyyy-MM";
export const YYYYMM = "yyyyMM";
export const YYYY_MM_JAPAN = "yyyy年MM月";
export const LOCAL_DATE_FORMAT = "yyyy-MM-dd";
export const YYYYMMDD = "yyyyMMdd";
export const YYYY_MM_DD = "yyyy-MM-dd";
export const YYYY_M_D = "yyyy-M-d";
export const YYYY_MM_DD_SLASH = "yyyy/MM/dd";
export const YYYY_M_D_SLASH = "yyyy/M/d";
export const YYYY_MM_DD_E_JAPAN = "yyyy年MM月dd日(E)";
export const M_D_JAPAN = "M月d日";
export const M_D_E_JAPAN = "M月d日(E)";
export const MM_DD_JAPAN = "MM/dd";
export const MM_DD_E_JAPAN = "MM/dd(E)";
export const M_D_E = "M/d(E)";
export const M_D = "M/d";
export const MM_DD_E = "MM/ddE";
export const D = "d";
export const E_JAPAN = "(E)";
export const LOCAL_TIME_FORMAT = "HH:mm:ss.SSS";
export const HHMMSS = "HHmmss";
export const HH_MM = "HH:mm";
export const SS = "ss";
export const LOCAL_DATE_TIME_FORMAT = `yyyy-MM-dd'T'HH:mm:ss.SSS`;
export const YYYY_MM_DD_T_HH_MM = "yyyy-MM-dd'T'HH:mm";
export const YYYYMMDDHHMM = "yyyyMMddHHmm";
export const YYYYMMDDHHMMSS = "yyyyMMddHHmmss";
export const YYYY_MM_DD_HH_MM = "yyyy-MM-dd HH:mm";
export const YYYY_M_D_HH_MM = "yyyy-M-d HH:mm";
export const YYYY_MM_DD_HH_MM_SS = "yyyy-MM-dd HH:mm:ss";
export const YYYY_M_D_HH_MM_SS = "yyyy-M-d HH:mm:ss";
export const YYYY_MM_DD_HH_MM_SLASH = "yyyy/MM/dd HH:mm";
export const YYYY_M_D_HH_MM_SLASH = "yyyy/M/d H:mm";
export const YYYY_MM_DD_HH_MM_SS_SLASH = "yyyy/MM/dd HH:mm:ss";
export const YYYY_MM_DD_H_MM_SS_SLASH = "yyyy/MM/dd H:mm:ss";
export const YYYY_M_D_HH_MM_SS_SLASH = "yyyy/M/d HH:mm:ss";
export const YYYY_MM_DD_HH_MM_JAPAN = "yyyy年MM月dd日HH:mm";
export const M_D_HH_MM_JAPAN = "M月d日HH:mm";
//# sourceMappingURL=time-format.js.map